// src/components/lesson/LessonStepShell.jsx

import React from "react";
import Banner from "../layout/Banner";

export default function LessonStepShell({ children }) {
  return (
    <div className="gwin-mobile-page min-h-[100dvh] bg-white">
      <Banner />

      <div className="w-full max-w-[100vw] overflow-x-hidden">
        {children}
      </div>
    </div>
  );
}